export const HeadcountChangesKey = 'headcountChanges';
